<template>
  <div class="shop_container">
    <!-- <van-tabs v-model="activeStatusId"
              lazy-render
              @change="onChange"
              title-active-color='#323233'
              title-inactive-color='#646566'
              class="shop_keep_tab">

      <van-tab v-for="(tab,index) in applyStatusList"
               :key="index"
               :name="tab.name">

        <template #title> {{tab.title}} <div id="tab_title"> <van-badge :content="tab.count"
                       v-if="tab.count>0" /></div></template>
      </van-tab>

    </van-tabs> -->
    <!-- tab切换内容 -->
    <div>
      <!-- 申请店长 -->
      <div class="shop_keep_box"
           v-if="activeStatusId == '0'">
        <!-- 货款 -->
        <div class="keeper_box goods">
          <div class="keeper_loan">
            <!-- 左侧 -->
            <div class="keeper_loan_tag">
              <svg class="keeper_loan_icon"
                   aria-hidden="true">
                <use xlink:href="#icon-huokuan"
                     style="padding:0;margin:0;"></use>
              </svg>
              <div class="keeper_describe">货款<span id="goods_status"
                      v-if="status == true">（未提交）</span><span v-if="status == false"
                      id="goods_status_pass">（已通过）</span></div>

            </div>
            <!-- 右侧 -->
            <div class="keep_loan_status"
                 v-if="status"
                 @click="goApply('0')">
              <span class="keep_loan_status_apl">立即提交</span>
              <span class="keep_loan_status_icon"><van-icon name="arrow" /></span>
            </div>
            <div class="keep_loan_fail"
                 v-else>
              <span class="keep_loan_status_apl">立即提交</span>
              <span class="keep_loan_status_icon"><van-icon name="arrow" /></span>
            </div>
          </div>
          <div>

          </div>
        </div>
        <!-- 代理商 -->
        <!-- <div class="keeper_box">
          <div class="keeper_loan">
            <div class="keeper_loan_tag">
              <svg class="keeper_loan_icon"
                   aria-hidden="true">
                <use xlink:href="#icon-dailishang"
                     style="padding:0;margin:0"></use>
              </svg>
              <div class="keeper_describe">代理商</div>

            </div>
            <div class="keep_loan_status"
                 v-if="status"
                 @click="goApply('1')">
              <span class="keep_loan_status_apl">立即申请</span>
              <span class="keep_loan_status_icon"><van-icon name="arrow" /></span>
            </div>
            <div class="keep_loan_fail"
                 v-else>
              <span class="keep_loan_status_apl">立即申请</span>
              <span class="keep_loan_status_icon"><van-icon name="arrow" /></span>
            </div>
          </div>
          <div>

          </div>
        </div> -->
        <!-- 公司服务 -->
        <div class="keeper_box">
          <div class="keeper_loan">
            <!-- 左侧 -->
            <div class="keeper_loan_tag">
              <svg class="keeper_loan_icon"
                   aria-hidden="true">
                <use xlink:href="#icon-gongsi"
                     style="padding:0;margin:0"></use>
              </svg>
              <div class="keeper_describe">公司服务<span id="goods_status"
                      v-if="companyStatus == true">（未提交）</span><span v-if="companyStatus == false"
                      id="goods_status_pass">（已提交）</span></div>

            </div>
            <!-- 右侧 -->
            <div class="keep_loan_status"
                 v-if="companyStatus"
                 @click="goApply('2')">
              <span class="keep_loan_status_apl">立即提交</span>
              <span class="keep_loan_status_icon"><van-icon name="arrow" /></span>
            </div>
            <div class="keep_loan_fail"
                 v-else>
              <span class="keep_loan_status_apl">立即提交</span>
              <span class="keep_loan_status_icon"><van-icon name="arrow" /></span>
            </div>
          </div>
          <div>

          </div>
        </div>
      </div>
      <!-- 我的申请 带分页 -->
      <div>
        <!--空状态 -->
        <div class="noOrders"
             v-if="applyList.length == 0 && activeStatusId == '1'">
          <img src="../../../assets/images/keepEmpty.png"
               alt />

          <div>暂无申请信息</div>

        </div>
        <div v-if="activeStatusId == '1' && applyList.length > 0">
          <van-list v-model="
           loading"
                    :finished="finished"
                    finished-text="没有更多了~"
                    error-text="加载失败,请重试!"
                    @load="onLoad">
            <div class="mine_apply_box">
              <div class="mine_apply_content">
                <div class="mine_box"
                     v-for="(item,index) in applyList"
                     :key="index">
                  <div class="mine_apply_main">
                    <!-- 左侧 -->
                    <div class="mine_apply_left">
                      <div class="mine_apply_type">申请类型：<span v-if="item.examinedType == 0">货款 </span><span v-if="item.examinedType == 1">代理商 </span><span v-if="item.examinedType == 2">公司服务 </span></div>
                      <div class="mine_apply_time">申请时间：{{item.applyTime}}</div>
                    </div>
                    <!-- 右侧 -->
                    <div class="mine_apply_status"
                         v-if="item.examinedStatus == 1">审核中</div>
                    <div class="mine_apply_status pass"
                         v-if="item.examinedStatus == 4">审核通过</div>
                    <div class="mine_apply_status finished"
                         v-if="item.examinedStatus == 2">审核完成待通过</div>
                    <div v-if="item.examinedStatus == 3">
                      <div class="fail">审核不通过</div>
                      <div class="reason"
                           @click="viewReason(item.errorSoure)">查看原因<van-icon name="arrow"
                                  id="icon" /></div>
                    </div>

                  </div>
                  <div class="mine_apply_down"
                       v-if="item.examinedStatus == 2">
                    <p>温馨提示：您将于下个月1-7日成为店长</p>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>

    </div>

    <!-- 加载中 -->
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>

import {
  Tab,
  Tabs,
  Card,
  Button,
  Panel,
  Dialog,
  Toast,
  List,
  PullRefresh,
  Loading,
  Notify,
  Form,
  Field,
  Overlay,
  Popup,
  Badge,
  Icon,
} from "vant";
import loading from "../../components/loading/loading";
import serviceUser from "../../api/user/index";
import serviceApply from "../../api/apply/index";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Card.name]: Card,
    [Button.name]: Button,
    [Panel.name]: Panel,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Loading.name]: Loading,
    [Form.name]: Form,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Overlay.name]: Overlay,
    [Badge.name]: Badge,
    [Icon.name]: Icon,
    loading
  },
  props: {},
  data () {
    return {
      status: null,
      companyStatus: null,
      activeStatusId: '0',
      applyStatusList: [
        { name: "0", title: "申请店长", count: '0' },
        { name: "1", title: "我的申请", count: '0' },
      ],
      applyList: [],
      firstLoading: false,
      //加载中loading
      isLoading: false,
      // 加载更多分页
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    goApply (type) {
      if (type == '0') {
        this.$router.push({ name: "loan" });
      } else if (type == '1') {
        this.$router.push({ name: "agent" });
      } else if (type == '2') {
        this.$router.push({ name: "compamyServe" });

      }

    },
    // tab 切换
    onChange (activeStatusId) {
      this.isLoading = true
      // console.log(activeStatusId, 'name');
      if (activeStatusId == '0') {
        this.getData()
      } else {
        this.isLoading = false
        this.finished = false
        this.page = 1
        this.onLoad()
        this.applyList = []
        this.changeUnReadMessageStatus()
      }
    },
    // 获取我的申请数量
    getKeeperCount () {
      this.isLoading = true
      return serviceUser
        .unReadMessageCount()
        .then((res) => {
          if (res.statusCode == 200) {
            if (res.data <= 99) {
              console.log(this.applyStatusList[1]);
              this.applyStatusList[1].count = res.data
            } else {
              this.applyStatusList[1].count = '99+'
            }
            return res
          } else {
            Toast(errors);
          }

        })
        .catch((err) => {
          // Toast(err);
        });
    },

    // 获取是否禁用立即申请
    getDisableApply () {
      this.isLoading = true
      return serviceApply
        .apllyQualification()
        .then((res) => {
          if (res.statusCode == 200) {
            // 修改返回是否可点击 0 是 都不可点击 1是都可点击 2是货款可点击 3是公司服务可点击
            if (res.data == 0) {
              this.status = false
              this.companyStatus = false
            } else if (res.data == 1) {
              this.status = true
              this.companyStatus = true
            } else if (res.data == 2) {
              this.status = true
              this.companyStatus = false
            } else if (res.data == 3) {
              this.status = false
              this.companyStatus = true
            }

          } else {
            Toast(errors);
          }
          return res
        })
        .catch((err) => {
          // Toast(err);
        });

    },
    // promise all 统一处理loading(第一个tab)
    getData () {
      Promise.all([this.getKeeperCount(), this.getDisableApply()]).then(res => {
        // console.log(res);
        this.isLoading = false
      })
    },
    //下拉加载列表
    onLoad () {
      // if (this.applyList.length == 0 && this.loading == true) {
      //   this.isLoading = true
      // }
      try {
        serviceApply
          .applicationList(this.page, this.pageSize)
          .then((res) => {
            if (res.statusCode == 200) {
              const results = res.data.items
              this.applyList.push(...results)
              this.isLoading = false
              this.loading = false;
              if (results.length) {
                // 有，则更新获取下一个数据的页码
                this.page++
              } else {
                // 没有，则将加载状态finished设置为结束
                this.finished = true
              }
            } else {
              Toast(errors);
            }

          })
          .catch((err) => {
            // Toast(err);
          });
      } catch (errors) {
        // Toast(errors);

      } finally {

      }
    },
    // 修改我的数量接口
    changeUnReadMessageStatus () {
      this.isLoading = true
      return serviceApply
        .changeUnReadMessageStatus()
        .then((res) => {
          if (res.statusCode == 200) {
            this.isLoading = false
            if (res.data === true) {
              this.applyStatusList[1].count = '0'
            }

            // this.status = res.data
          } else {
            Toast(errors);
          }
          return res
        })
        .catch((err) => {
          // Toast(err);
        });

    },
    // 查看原因
    viewReason (reason) {
      Dialog.alert({
        title: '审核不通过原因',
        message: reason,
        messageAlign: 'center',
        confirmButtonText: '我知道了'
      }).then(() => {
        // on close
      });
    }
  },
  created () { },
  mounted () {
    //获取未读数量和
    this.getData()
    // this.onLoad()
  }
};
</script>
<style lang="less" >
@deep: ~'>>>';
// .van-dialog__message {
//   line-height: 22px !important;
// }
#goods_status {
  color: #f00724;
}
#goods_status_pass {
  color: #19c15c;
}

.shop_container {
  width: 100%;
  position: relative;
  height: calc(100vh - 60px);
  overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 60px;
  .van-list__error-text,
  .van-list__finished-text,
  .van-list__loading {
    line-height: 16px;
  }
  .noOrders {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding-top: 0;
  }
  .shop_keep_tab {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 2;
  }
  .van-tabs__wrap {
    height: 48px;
  }
  .van-tab {
    height: 48px !important;
  }
  @{deep}.van-tab__pane-wrapper {
    height: 100%;
  }
  // @{deep} .van-info {
  //   right: -10px !important;
  // }
  #tab_title {
    position: absolute;
    top: 8px;
    right: 48px;
  }
  // 申请店长
  .shop_keep_box {
    box-sizing: border-box;
    margin-top: 8px;
    padding: 0 16px 20px 16px;
    overflow: hidden;
    .goods {
      margin-top: 10px;
      // margin-top: 55px;
      margin-bottom: 8px;
    }
    .keeper_box {
      height: 74px;
      background: #ffffff;
      box-shadow: 0px 4px 8px 1px #ebebeb;
      border-radius: 8px 8px 8px 8px;
      padding: 0 16px;
      border: 1px solid #e6e6e6;
      margin-bottom: 8px;
      .keeper_loan {
        padding-right: 8px;
        line-height: 74px;
        .keeper_loan_tag {
          height: 74px;
          line-height: 74px;
          float: left;

          .keeper_describe {
            display: inline-block;
            vertical-align: middle;
            font-size: 18px;
            font-weight: 500;
            color: #333333;
            margin-left: 5px;
          }
        }
        .keeper_loan_icon {
          display: inline-block;
          vertical-align: middle;
          width: 16px;
          height: 18px;
          // margin-top: -3px;
        }
        .keep_loan_status {
          position: relative;
          float: right;
          color: #f00724;
        }
        .keep_loan_fail {
          position: relative;
          float: right;
          color: #c8c8c8;
        }
        .keep_loan_status_apl {
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
        }
        .keep_loan_status_icon {
          position: absolute;
          top: 3px;
          // display: inline-block;
          // vertical-align: middle;
        }
      }
    }
  }
  // 我的申请
  .mine_apply_box {
    // min-height: calc(100vh - 48px);
    padding: 0 16px;
    .mine_apply_content {
      padding: 0 0 16px 0;
      overflow: hidden;
      .mine_box {
        background: #ffffff;
        box-shadow: 0px 4px 8px 1px #ebebeb;
        border-radius: 8px 8px 8px 8px;
        margin-top: 8px;
        border: 1px solid #e6e6e6;
        box-sizing: border-box;
        padding: 16px 12px;
      }
      .mine_apply_main {
        display: flex;
        justify-content: space-between;
        align-content: center;

        .mine_apply_left {
          font-size: 14px;
          color: #333333;
          line-height: 14px;
          .mine_apply_type {
            height: 20px;
            line-height: 20px;
          }
          .mine_apply_time {
            height: 20px;
            line-height: 20px;
            margin-top: 8px;
          }
        }
        .mine_apply_status {
          // margin-top: 14px;
          align-self: center;
          color: #f28424;
        }
        .pass {
          color: rgba(39, 180, 95, 1);
        }
        .finished {
          color: rgba(242, 132, 36, 1);
        }
        .fail {
          color: rgba(240, 7, 36, 1);
        }
        .reason {
          margin-top: 8px;
          position: relative;
          color: rgba(153, 153, 153, 1);
          #icon {
            // vertical-align: middle;
            // margin-top: 3px;
            position: absolute;
            top: 3px;
            display: inline-block;
          }
        }
      }
      .mine_box:first-child {
        margin-top: 64px;
      }
      .mine_apply_down {
        height: 25px;
        border-top: 1px solid #e6e6e6;
        margin-top: 16px;
        p {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.4);
          line-height: 14px;
        }
      }
    }
  }
}
</style>